import { PlanoEssencialBrandingLargeIcon } from '@ferreri/prever-component-lib';
import { usePlanDetails } from '..';

export const PlanoEssencialDetails: usePlanDetails = {
  name: 'Essencial',
  basePrice: 59,
  title: 'Cuidados essenciais para os momentos mais difíceis.',
  description: 'Essencial é garantir proteção para quem você ama.',
  heroUri: 'assets/img/essencial.webp',
  icon: <PlanoEssencialBrandingLargeIcon />,
  buyButtonLabel: 'Contratar Essencial',
  includedDependents: {
    description:
      'Contratante (titular), cônjuge, filhos solteiros e até dois dependentes (netos ou sobrinhos), até 25 anos com dependência financeira do titular, estão incluídos no valor da mensalidade. Você ainda pode simular a adição de outros dependentes.',
    alert:
      'Além do titular deve haver ao menos 1 dependente maior de 18 anos e não curatelado.',
  },
  benefits: [
    {
      title: 'Condições para inclusão de outros dependentes.',
      items: [
        'Até 2 dependentes com grau de parentesco (neto ou sobrinho), acima de 25 anos: adicional de 10% por dependente. Netos e sobrinhos até 25 anos não têm taxa adicional desde que residam sob dependência financeira do titular.',
        'Até 5 dependentes com ou sem grau de parentesco até 79 anos: adicional de 30% por dependente;',
        'Dependentes adicionais a partir de 80 anos (na data de adesão do plano): adicional de 80% por dependente (exceto pais e sogros).',
      ],
    },
    {
      title: 'Beneficiários',
      description:
        'Pai, mãe, sogro, sogra e filhos solteiros acima de 25 anos, acréscimo de 10% por pessoa.',
    },
    {
      title: 'Cobertura e assistências',
      items: [
        'Translado até 100km',
        'Teleconsultas',
        'Orientação jurídica',
        'Acolhimento ao luto',
        'Apoio ortopédico',
        'Assistência funeral',
      ],
    },
    {
      title: 'Assistência funeral',
      items: [
        'Cobertura em Porto Alegre e região metropolitana',
        'Atendimento funerário 24 horas',
        'Assessoria para realização do funeral',
        'Urna com alça parreira e visor',
        'Ornamentação de urna',
        'Tanatopraxia inclusa',
        'Paramentos para cerimônia fúnebre',
        'Coroa de flores com faixa de homenagem',
        'Orientação do processo de Registro de Óbito',
        'Veículo para remoção',
        'Translado incluso em raio de 100km de distância',
        'Local para velório',
        'Carência de 24 horas para morte acidental',
        'Carência de 90 dias para óbito em Porto Alegre ou região metropolitana',
      ],
    },
    {
      title: 'Angelus Memorial e Crematório',
      items: [
        '9 capelas para velório com espaço reservado para a família;',
        'Suítes privativas para descanso;',
        'Segurança e monitoramento 24h;',
        'Serviço de copa;',
        'Equipe de apoio durante o velório;',
        'Infraestrutura para velório online.',
      ],
    },
    {
      title: 'Assistência Sepultamento',
      description:
        'Titular ou dependentes do plano podem optar, caso desejarem, pela cremação ou locação trienal de jazigo. Nas cidades onde a contratada não possua cemitérios e crematórios próprios ou parceiros indicados, o associado terá direito há uma cobertura de até R$ 3.000,00 (três mil reais), para locação de jazigo ou cremação. Benefício não incluído no plano. Consulte as condições para a adesão da Assistência Sepultamento.',
      items: [],
      alert: '',
    },
    {
      title: 'Benefícios em vida',
      description:
        'Além da assistência funeral, você garante benefícios em vida para aproveitar melhor os dias, sem se preocupar.',
      items: [
        {
          title: 'Desconto em medicamentos',
          description:
            'Aproveite mais de 2.000 medicamentos com até 80% de desconto na rede de Farmácias credenciadas!',
        },
        {
          title: 'Clube de vantagens',
          description:
            'O Clube de vantagens Angeplus oferece para todos os associados descontos e vantagens para comprar e vender com economia. É fácil, rápido e gratuito!',
        },
      ],
    },
    {
      title: 'Acolhimento ao luto',
      items: [
        'Acompanhamento psicológico de aconselhamento e suporte que auxilia titulares e dependentes no processo do luto com 3 sessões remotas individuais e gratuitas.',
      ],
    },
    {
      title: 'Assistência de apoio ortopédico',
      items: [
        'Empréstimo de equipamento ortopédico gratuito por 30 dias: cadeira de banho, cadeira de rodas, andador 3 barras. Nas cidades onde a contratada possua operação própria de atendimento.',
      ],
    },
    {
      title: 'Teleconsultas gratuitas',
      items: [
        'Através do APP Angeplus, em "Cuidados e Saúde" você tem acesso às teleconsultas gratuitas disponíveis para o seu plano.',
      ],
    },
    {
      title: 'Orientação jurídica pós-óbito',
      items: [
        'Profissionais do Direito disponíveis para orientações sobre dúvidas legais relacionadas ao óbito.',
      ],
    },
  ],
};
